module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-1 my-2"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "headline ma-0 grey--text text--darken-2"
  }, [_vm._v(" " + _vm._s(_vm.mk.name) + " ")])])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "px-2",
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.mk.logos), function(logo, i) {
    return _c('v-flex', {
      key: i + 'lg',
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-card-media', {
      staticClass: "ma-2",
      attrs: {
        "src": _vm.markenlogo(logo.dateiserverpfad),
        "height": "90px",
        "width": "150px",
        "contain": ""
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.mk.firmen), function(firma, b) {
    return _c('v-flex', {
      key: b + 'fa',
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(firma.name) + " ")])]), _vm._v(" "), _vm._l((firma.adressen), function(adresse, c) {
      return _c('v-flex', {
        key: c + 'ad',
        attrs: {
          "xs12": ""
        }
      }, [_c('p', [_vm._v(" \n                        " + _vm._s(adresse.strasse) + " "), _c('br'), _vm._v("\n                        " + _vm._s(adresse.plz) + " " + _vm._s(adresse.ort) + "\n                    ")])])
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey darken-3 mt-2 pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoEdit(_vm.mk.id)
      }
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("build")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.commitDelete
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('delete-modal', {
    attrs: {
      "showDialog": _vm.showDialog
    },
    on: {
      "update:showDialog": function($event) {
        _vm.showDialog = $event
      },
      "committed": _vm.toDestroy
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b8ec442","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marken/singleMarken.vue
// module id = 328
// module chunks = 0